import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { SupportProgramService } from 'src/app/services/support-program.service';

@Component({
  selector: 'app-donations',
  templateUrl: './donations.component.html',
  styleUrl: './donations.component.scss'
})
export class DonationsComponent implements OnInit {
  public last_beneficiaries: Array<any> = [];
  public last_benefactors: Array<any> = [];
  public counters: any = {
    beneficiaries: 0,
    benefactors: 0,
  }
  public locale: string = this.languageService.getLanguage();
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private supportProgramService: SupportProgramService,
    private languageService: LanguageService
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId) && (typeof Sticky !== 'undefined')) {
      new Sticky('.sticky');
    }

    this.getSupportProgramData();
  }

  getSupportProgramData() {
    this.supportProgramService.getSupportProgramData().subscribe( {
      next: (data: any) => {
        this.last_beneficiaries = data.last_beneficiaries;
        this.last_benefactors = data.last_benefactors;
        this.counters = {
          beneficiaries: data.beneficiaries_counter,
          benefactors: data.orders_counter,
        }
      },
      complete: () => {},
      error: (error: any) => {
        console.log('Error', error);
      }
    });
  }
}
